export { default } from "./VerifyOtpForm.jsx";
